import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-double-up', 'ChevronDoubleUp', [["path",{"d":"m18 12-6-6-6 6m12 6-6-6-6 6","key":"svg-0"}]]);